import {
  CustomFieldProps,
  DateFieldProps,
  DynamicField,
  DynamicForm,
  EditorFieldProps,
  FieldVariant,
  SelectFieldProps,
  SelectOption,
  TextFieldProps,
} from '@/components/form-builder/form-builder.types';
import { PlanningReviewDetailsComponent } from '@/components/shared/planning-review-details/planning-review-details.component';
import { PresenceDataTableComponent } from '@/components/shared/presence-data-table/presence-data-table.component';
import { MeetingRepository } from '@/store/meeting-state/meeting-state.repository';
import { MEETING_STATUS, Participant } from '@/types/meeting.types';
import { map, of } from 'rxjs';

interface IgetConveneMeetingFormObjectProps {
  store: MeetingRepository;
  status?: MEETING_STATUS;
  invitedMembers?: Participant[];
  plannedDossiers: any[];
}

export const getInspectConvenedMeetingFormObject = ({ store, plannedDossiers }: IgetConveneMeetingFormObjectProps): DynamicForm => {
  const comOptionsField: DynamicField<SelectFieldProps> = {
    label: 'meeting.form.com.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    error: store.getNestedObservableError('comId'),
    isDisabled: of(true),
    props: {
      value: store.getObservable('comSelected'),
      options: [store.get<SelectOption>('comSelected')],
      filterEnabled: true,
    },
  };

  const dueDateField: DynamicField<DateFieldProps> = {
    label: 'meeting.form.dueDate.label',
    variant: FieldVariant.DATE,
    isRequired: false,
    error: store.getNestedObservableError('reunionDate'),
    isDisabled: of(true),
    props: {
      showTime: true,
      view: 'date',
      value: store.getNestedObservable<Date>('dto', 'reunionDate').pipe(map(date => (date ? new Date(date) : null))),
    },
  };

  const titleField: DynamicField<TextFieldProps> = {
    label: 'meeting.form.title.label',
    variant: FieldVariant.TEXT,
    isRequired: false,
    isDisabled: of(true),
    error: store.getNestedObservableError('emplacement'),
    props: {
      value: store.getNestedObservable<string>('dto', 'emplacement'),
    },
  };

  const generalObjectField: DynamicField<EditorFieldProps> = {
    label: 'meeting.form.general.label',
    variant: FieldVariant.EDITOR,
    isRequired: true,
    isDisabled: of(true),
    error: store.getNestedObservableError('object'),
    props: {
      height: '200px',
      value: store.getNestedObservable<string>('dto', 'object'),
    },
  };

  const presenceTableField: DynamicField<CustomFieldProps> = {
    label: 'meeting.presence.table.title',
    variant: FieldVariant.CUSTOM,
    isRequired: false,
    error: store.getNestedObservableError('participants'),
    props: {
      component: PresenceDataTableComponent,
      injectKeys: ['createAction', 'disabled'],
      createAction: () => undefined,
      disabled: true,
    },
  };

  const planningReviewDetailsField: DynamicField<CustomFieldProps> = {
    label: 'meeting.planning.reviewDetails.label',
    variant: FieldVariant.CUSTOM,
    isRequired: false,
    props: {
      component: PlanningReviewDetailsComponent,
      injectKeys: ['planningReviewDetails', 'isInspectMode'],
      planningReviewDetails: plannedDossiers,
      isInspectMode: true,
    },
  };

  const remarqueField = {
    label: '',
    variant: FieldVariant.EDITOR,
    isRequired: false,
    props: {
      height: '320px',
      value: store.getNestedObservable<string>('dto', 'note'),
      onChange: (value: string) => {
        store.setNested('dto', 'note', value);
      },
    },
  };

  return {
    title: 'meeting.form.title',
    orientation: 'horizontal',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [comOptionsField, dueDateField],
          },
          {
            fields: [titleField],
          },
          {
            fields: [generalObjectField],
          },
          {
            fields: [presenceTableField],
          },
          {
            fields: [planningReviewDetailsField],
          },
        ],
      },
      {
        title: 'meeting.form.remarque.label',
        gridItems: [
          {
            fields: [remarqueField],
          },
        ],
      },
    ],
  };
};
